import { useCallback, useState } from "react";
import { useToast } from "../ui/useToast";

export function useAsyncAction() {
  const toast = useToast();
  const [busy, setBusy] = useState(false);

  const run = useCallback(
    async (label: string, fn: () => Promise<void>, successLabel?: string) => {
      const toastId = toast.loading(label);
      setBusy(true);
      try {
        await fn();
        toast.success(successLabel ?? `${label.replace(/…$/, "")} completato`, toastId);
      } catch (e) {
        const msg = e instanceof Error ? e.message : String(e);
        toast.error(msg, toastId);
        throw e;
      } finally {
        setBusy(false);
      }
    },
    [toast],
  );

  return { run, busy };
}
